<template>
  <section class="home-hero" id="home-hero">
    <div class="container">
      <div class="content">
        <div class="hero-text">
          <h2 class="h1">A te irodád.<br />A mi szakértelmünk.</h2>
          <p>
            Olyan partnert keresel, aki leegyszerűsíti az irodakeresést, mindent
            egy kézben tart és biztosítja a legjobb bérleti feltételeket? Az
            Offie segít eligazodni a budapesti irodapiacon.
          </p>
        </div>

        <div class="hero-content">
          <h2 class="h3">Ügyfelek, akik megbíznak bennünk</h2>
          <ul class="companies">
            <li>
              <a href="#testimonials"
                ><img
                  src="@/assets/logo/bayer-logo.png"
                  width="160"
                  height="160"
                  alt="Bayer"
              /></a>
            </li>
            <li>
              <a href="#customers-say"
                ><img
                  src="@/assets/logo/leanpay-logo.png"
                  width="160"
                  height="160"
                  alt="LeanPay"
              /></a>
            </li>
            <li>
              <a href="#customers-say"
                ><img
                  src="@/assets/logo/rocket-boy-logo.png"
                  width="160"
                  height="160"
                  alt="Rocket boy"
              /></a>
            </li>
            <li>
              <a href="#customers-say"
                ><img
                  src="@/assets/logo/applied-ev-logo.png"
                  width="160"
                  height="160"
                  alt="Applied EV"
              /></a>
            </li>

            <li class="lg:ml-2 lg:flex lg:items-center mt-4 lg:mt-0">
              <a href="#customers-say"
                ><img
                  src="@/assets/logo/bluebird-logo-grey.svg"
                  alt="Bluebird"
                  class="bluebird"
                />
              </a>
            </li>
            <li class="lg:ml-2 lg:flex lg:items-center mt-4 lg:mt-0">
              <a href="#customers-say"
                ><img
                  src="@/assets/logo/veeva.png"
                  alt="Veeve"
                  width="160"
                  height="160"
                  class="grayscale veeva"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BlueBird from "@/components/icons/BlueBird.vue";

export default {
  name: "HomeHero",
  components: {
    // BlueBird,
  },
  data() {
    return {
      personal: this.$store.getters.getPersonal
    };
  }
};
</script>

<style lang="scss">
.home-hero {
  background-image: url("~@/assets/offie-hero-bg.svg");
  background-repeat: no-repeat;
  background-position: 60% 56%;
  background-size: 130vw;

  .content {
    // max-width: 60%;
    justify-content: center;
    margin-bottom: 54px;
  }

  .hero-text {
    margin-bottom: 90vw;
  }

  .hero-content {
    /* opacity: 0; */
    .companies {
      display: flex;
      padding: 0;
      flex-wrap: wrap;
      justify-content: center;
      li {
        flex: 0 0 50%;
        list-style: none;
        height: 80px;
        text-align: center;
        //margin-bottom: 24px;
        a {
          display: inline-block;
          .bluebird {
            max-width: 120px;
            height: auto;
            filter: grayscale(1);
          }
          .veeva {
            max-width: 80px;
            height: auto;
            filter: grayscale(1);
          }
        }
        img {
          display: block;
          height: 80px;
          width: auto;
        }
      }
    }
  }

  .container {
    // max-width: 50%;
  }

  @media screen and (min-width: $breakpoint) {
    padding: 0 !important;
    background-position: right 40%;
    // background-size: auto 108%;
    // background-size: 52vw auto;
    background-size: 52vw;
    height: calc(100vh - 280px);
    min-height: 632px;
    display: flex;
    align-items: center;
    .content {
      max-width: 66%;
      justify-content: flex-start;
      margin-bottom: 0;
    }

    .hero-text {
      margin-bottom: 32px;
      margin-right: 64px;
      .h1 {
        margin-bottom: 16px;
      }
      p {
        margin: 0;
      }
    }

    .hero-content {
      margin-bottom: 64px;
      .companies {
        width: auto;
        flex-wrap: nowrap;
        justify-content: flex-start;
        //max-width: 450px;
        li {
          flex: initial;
          text-align: left;
          //margin-right: 36px;
        }
      }
    }
  }
}
</style>
